import { useEffect, useState } from 'react';
import { editor } from '@/instance';

export const useImageCutoutHelper = () => {
    const [result, setResult] = useState({
        isImageCutout: false,
        isCutoutMainLayer: false,
    });

    useEffect(() => {
        const handle = editor.imageCutout.onImageCutoutChange((isImageCutout) => {
            const activeLayer = editor.active.get();
            setResult({
                isImageCutout,
                isCutoutMainLayer: isImageCutout && !activeLayer,
            });
        });
        return () => {
            editor.off(handle);
        };
    }, []);

    return {
        isImageCutout: result.isImageCutout,
        imageCutoutInfo: { isCutoutMainLayer: result.isCutoutMainLayer },
    };
};
